import Icon from 'veui/components/Icon'

Icon.register({
  flag: {
    paths: [
      {
        d: 'M9 35.37V44h1a2 2 0 110 4H5a2 2 0 110-4V2a2 2 0 114 0h20.9a2 2 0 01.9.21l2.85 1.42H41a4 4 0 014 4V33a4 4 0 01-4 4h-7.82a2 2 0 01-.9-.21l-2.84-1.42H9zm0-4h20.9a2 2 0 01.9.2L33.65 33H41V7.63h-7.82a2 2 0 01-.9-.2L29.45 6H9v25.37z'
      }
    ],
    width: '48',
    height: '48'
  }
})
